import { gql } from '@apollo/client';

export const PUBNUB_VIDEO_UPLOAD_LINK_UPDATED = gql`
  mutation PubNubVideoUploadLinkUpdated(
    $video_upload_link: PubNubVideoUploadLinkModel!
  ) {
    PubNubVideoUploadLinkUpdated(video_upload_link: $video_upload_link) @client
  }
`;
